module.exports = {
    className: "ContactUpdateLog",
    classNameLabel: "Contact Update Log",
    limit: 10,
    showExport: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "memberId",
            columnLabel: "member Id",
            type: "string"
        },
        {
            columnName: "contactType",
            columnLabel: "contact   Type",
            type: "string"
        },
        {
            columnName: "createdAt",
            columnLabel: "Date",
            type: "Date",
            show: true
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
}


// WEBPACK FOOTER //
// ./components/ContactUpdateLog/ContactUpdateLogSchema.js